var map = {
	"./2018-05-01-01.jpg": 7119,
	"./2018-11-11-01.jpg": 3449,
	"./2019-01-31-01.png": 1291,
	"./2019-02-04-01.jpg": 8904,
	"./2019-02-15-01.jpg": 694,
	"./2019-03-02-01.png": 3291,
	"./2019-03-14-01.jpg": 9116,
	"./2019-03-14-02.jpg": 3771,
	"./2019-03-15-01.jpg": 4179,
	"./2019-04-11-02.jpg": 7675,
	"./2019-04-12-01.jpg": 1917,
	"./2019-05-18-01.jpg": 8962,
	"./2019-06-03-01.jpg": 1585,
	"./2019-07-19-01.jpg": 3515,
	"./2019-07-31-01.jpg": 2965,
	"./2019-08-22-01.jpg": 5642,
	"./2020-02-26-01.jpg": 3680,
	"./2020-05-27-01.jpg": 1240,
	"./2020-10-16-01.jpg": 1890,
	"./2020-12-12-01.jpg": 2424,
	"./2020-12-16-01.jpg": 4836,
	"./2021-02-09-01.jpg": 9092,
	"./2022-10-17-01.png": 2231,
	"./2022-10-25-01.png": 3490,
	"./2023-07-28-01.png": 3906,
	"./2024-04-10-01.png": 527,
	"./2024-05-07-01.jpg": 4570,
	"./2024-07-10-01.jpg": 1432,
	"./2024-08-03-01.png": 7515,
	"./2024-09-01-01.jpg": 1648,
	"./2025-04-29-01.jpg": 1856,
	"./2025-05-01-01.jpg": 9451,
	"./2025-05-06-01.jpg": 5858,
	"./baseimage.png": 9742,
	"./news.psd": 4976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1572;